import { render, staticRenderFns } from "./generateReport.vue?vue&type=template&id=680e0b80&scoped=true&"
import script from "./generateReport.vue?vue&type=script&lang=js&"
export * from "./generateReport.vue?vue&type=script&lang=js&"
import style0 from "./generateReport.vue?vue&type=style&index=0&id=680e0b80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680e0b80",
  null
  
)

export default component.exports